import React, { Fragment } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import ScrollBars from "react-custom-scrollbars"
import PersonCard from "../../../widgets/PersonCard"
import PersonCardShape from "../../../../state/shapes/PersonCardShape"

const EmployeeSelectionContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  min-height: 300px;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding-top: 1em;
  padding-bottom: 1em;
  padding-left: 1em;
  margin-bottom: 1em;
`
const PersonCardContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.5em;
  margin: 0.25em;
`

const centerIcon = {
  paddingTop: "50%"
}
const CustomReportSelectedEmployees = ({
  onEmployeeSelection,
  employeeRemoved,
  selectedEmployees,
  includeDirectReportsChangeHandler
}) => {
  const onDragOver = e => {
    e.preventDefault()
  }
  const onDrop = e => {
    const employeeIdString = e.dataTransfer.getData("text/plain")
    const employeeId = Number.parseInt(employeeIdString, 10)
    if (
      !selectedEmployees.some(emp => {
        return emp.employeeId === employeeId
      })
    ) {
      onEmployeeSelection(employeeId)
    }
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <EmployeeSelectionContainer
            className="container droppable"
            onDragOver={e => {
              onDragOver(e)
            }}
            onDrop={e => {
              onDrop(e)
            }}
          >
            <ScrollBars autoHeight autoHeightMin={350}>
              {selectedEmployees && selectedEmployees.length > 0
                ? selectedEmployees.map(e => {
                    return (
                      <PersonCardContainer key={e.employeeId}>
                        <div className="row">
                          <div className="col-md-1">
                            <span
                              className="fa fa-minus-circle"
                              onClick={() => employeeRemoved(e.employeeId)}
                              style={centerIcon}
                            />
                          </div>

                          <div className="col-md-11">
                            <PersonCard
                              item={e}
                              highlightedItem={false}
                              showIncludeDirectCheckbox
                              includeDirectReportsChangeHandler={includeDirectReportsChangeHandler}
                            />
                          </div>
                        </div>
                      </PersonCardContainer>
                    )
                  })
                : null}
            </ScrollBars>
          </EmployeeSelectionContainer>
        </div>
      </div>
    </Fragment>
  )
}

CustomReportSelectedEmployees.propTypes = {
  onEmployeeSelection: PropTypes.func.isRequired,
  employeeRemoved: PropTypes.func.isRequired,
  selectedEmployees: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)),
  includeDirectReportsChangeHandler: PropTypes.func.isRequired
}

CustomReportSelectedEmployees.defaultProps = {
  selectedEmployees: null
}
export default CustomReportSelectedEmployees



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/LocationsEmployeesSelection/CustomReportSelectedEmployees.jsx